module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "indicator-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "indicator-icons"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "indicator-groups"
  }, _vm._l((_vm.indicators), function(indicator, group_index) {
    return _c('div', {
      key: group_index,
      staticClass: "indicator-group",
      class: {
        active: _vm.isGroupActive(group_index)
      }
    }, [_c('h3', [_c('img', {
      attrs: {
        "src": _vm.loadImg(indicator.icon)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(indicator.name)
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "show-all",
      on: {
        "click": function($event) {
          _vm.setAllActive(group_index)
        }
      }
    }, [_vm._v("select all")]), _vm._v(" "), _c('ul', _vm._l((indicator.indicators), function(i) {
      return (i.name !== 'Overview') ? _c('li', {
        class: {
          active: i.active
        },
        on: {
          "click": function($event) {
            _vm.setActiveIndicator(i, group_index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.loadImg(i.image)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "indicator-name",
        domProps: {
          "textContent": _vm._s(i.name)
        }
      })]) : _vm._e()
    }))])
  }))]), _vm._v(" "), (_vm.slickVisible) ? _c('div', {
    staticClass: "slick-wrapper"
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "id": "indicator-cards-slider",
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.flattened_indicators), function(indicator, index) {
    return (indicator.name !== 'Overview') ? _c('div', {
      key: index,
      staticClass: "indicator-card",
      class: [{
        'card-slide': (indicator.first || _vm.indicators[indicator.group].expanded)
      }, 'group-indicator-' + indicator.group]
    }, [(indicator.first && !_vm.indicators[indicator.group].expanded) ? _c('div', {
      staticClass: "vertical-collapsed",
      on: {
        "click": function($event) {
          _vm.toggleIndicatorGroup(indicator.group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "icon",
      attrs: {
        "src": _vm.loadImg(_vm.indicators[indicator.group].icon)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.indicators[indicator.group].name))])]) : (_vm.indicators[indicator.group].expanded) ? _c('div', [_c('div', {
      staticClass: "indicator-card-top"
    }, [(indicator.first) ? _c('span', {
      staticClass: "indicator-card-top__left"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadImg(_vm.indicators[indicator.group].icon)
      }
    }), _vm._v("\n                " + _vm._s(_vm.indicators[indicator.group].name) + "\n              ")]) : _vm._e(), _vm._v(" "), (indicator.last) ? _c('span', {
      staticClass: "indicator-card-top__right",
      on: {
        "click": function($event) {
          _vm.toggleIndicatorGroup(indicator.group)
        }
      }
    }, [_vm._v("\n                collapse\n                "), _c('i', {
      staticClass: "fa fa-chevron-left",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "indicator-details-card",
      class: {
        context: indicator.group == 0, core: indicator.group == 1, opp: indicator.group == 2, active: indicator.active
      }
    }, [(indicator.thumb) ? _c('img', {
      attrs: {
        "src": _vm.loadImg(indicator.thumb)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "indicator-details-content"
    }, [_c('h5', [_vm._v("\n                  " + _vm._s(indicator.fullname) + "\n                  "), (indicator.composite) ? _c('span', {
      staticClass: "composite-score",
      domProps: {
        "innerHTML": _vm._s(indicator.composite)
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "indicator-description"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadImg(indicator.image)
      }
    }), _vm._v("\n                  " + _vm._s(indicator.description) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "indicator-calculation"
    }, [_c('h6', [_vm._v("How Indicator Was Calculated")]), _vm._v("\n                  " + _vm._s(indicator.calculation) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "indicator-source"
    }, [_c('h6', [_vm._v("Data Source (and date):")]), _vm._v("\n                  " + _vm._s(indicator.source) + "\n                ")])])])]) : _vm._e()]) : _vm._e()
  }))], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("VIEW COMPOSITE RESULTS "), _c('small', [_vm._v("Toggle indicators to filter data")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c036438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Indicators.vue
// module id = 118
// module chunks = 0